<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10 mr-auto ml-auto">
        <div class="card card-wizard active">
          <form-wizard
            @on-change="onTabChange"
            color="#66615B"
            title="Purchase New Connection Point"
            subtitle
            shape="tab"
            ref="wizardForm"
            transition="fade"
          >
            <template slot="step" slot-scope="props">
              <wizard-step
                :tab="props.tab"
                :transition="props.transition"
                :key="props.tab.title"
                :index="props.index"
              ></wizard-step>
            </template>
            <tab-content title="Select Site" icon="fas fa-map-pin">
              <div class="row">
                <div class="col-lg-12">
                  <purchase-leaflet-map
                    @next-tab="nextTabOnMaps"
                  ></purchase-leaflet-map>
                </div>
              </div>
            </tab-content>
            <tab-content
              title="Select Connection Point"
              icon="fas fa-plug"
              :before-change="() => validateStep('connectionDetails')"
            >
              <div>
                <connection-details
                  ref="connectionDetails"
                  @on-validated="onStepValidated"
                  @connection-change="onConnectionChange"
                  :stations="stations"
                  :default-station="defaultStation"
                  :siteId="siteId"
                  :siteInformation="siteInformation"
                  :is-connection-details-tab="isConnectionDetailsTab"
                ></connection-details>
              </div>
            </tab-content>
            <tab-content title="Payment" icon="far fa-credit-card">
              <div>
                <payment-details
                  :summary="wizardModel"
                  :is-payment-tab="isPaymentTab"
                  @next-tab="nextTabOnPayment"
                ></payment-details>
              </div>
            </tab-content>
            <tab-content title="Confirmation" icon="fas fa-check">
              <payment-confirmation
                :summary="wizardModel"
                :payment-details="paymentDetails"
              ></payment-confirmation>
            </tab-content>
            <template slot="footer" slot-scope="props">
              <div class="wizard-footer-left">
                <wizard-button
                  v-if="props.activeTabIndex > 0 && !props.isLastStep"
                  @click.native="props.prevTab()"
                  :style="props.fillButtonStyle"
                  >Previous</wizard-button
                >
              </div>
              <div class="wizard-footer-right">
                <wizard-button
                  v-if="[1].includes(props.activeTabIndex)"
                  @click.native="props.nextTab()"
                  class="wizard-footer-right"
                  :style="props.fillButtonStyle"
                  >Next</wizard-button
                >
              </div>
            </template>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  FormWizard,
  TabContent,
  WizardButton,
  WizardStep,
} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import PurchaseLeafletMap from "src/components/Dashboard/Views/Maps/PurchaseLeafletMap.vue";
import ConnectionDetails from "src/components/Dashboard/Views/Purchase/Wizard/ConnectionDetails.vue";
import { EventBus } from "src/util/event-bus.js";
import HTTP from "src/util/http-common.js";
import NotificationTemplate from "src/components/Dashboard/Views/Components/NotificationTemplate";
import PaymentDetails from "src/components/Dashboard/Views/Purchase/Wizard/PaymentDetails.vue";
import PaymentConfirmation from "src/components/Dashboard/Views/Purchase/Wizard/PaymentConfirmation.vue";

export default {
  //component code
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    WizardStep,
    PurchaseLeafletMap,
    ConnectionDetails,
    PaymentDetails,
    PaymentConfirmation,
  },
  data() {
    return {
      stations: [],
      defaultStation: "",
      siteId: 0,
      connectionId: 0,
      wizardModel: {},
      isPaymentTab: false,
      isConnectionDetailsTab: false,
      paymentDetails: {},
      onHoldConnectionId: 0,
      siteInformation: {},
    };
  },
  mounted() {
    window.addEventListener("beforeunload", this.leaving);
    var p = localStorage.getItem("permissions");
    var pr = JSON.parse(p);
    var permissions = pr.permissions;

    var canShowBooking = permissions.includes("booking.post");

    if (canShowBooking === false) {
      this.$router.push({ path: "/" });
    }
  },
  //   beforeUnmount() {
  //   window.removeEventListener('beforeunload', this.leaving)
  // },
  beforeRouteLeave(to, from, next) {
    this.onHoldConnectionId = parseInt(
      localStorage.getItem("onHoldConnectionId")
    );
    this.connectionId = this.onHoldConnectionId;
    if (this.onHoldConnectionId && this.isPaymentTab) {
      // Prompt the user with a confirmation message
      if (
        window.confirm("You have unsaved changes. Do you really want to leave?")
      ) {
        this.releaseConnection();
        // Continue with the route change
        next();
      } else {
        // Cancel the route change
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    leaving: function (event) {
      event.preventDefault();
      this.onHoldConnectionId = parseInt(
        localStorage.getItem("onHoldConnectionId")
      );
      this.connectionId = this.onHoldConnectionId;
      if (this.onHoldConnectionId && this.isPaymentTab) {
        try {
          this.releaseConnection();
        } catch (error) {
          console.log(error);
        }
        event.returnValue = "";
      }
    },
    getStations(siteId) {
      HTTP.get(`api/v1/site/station/list`, {
        params: {
          site_id: siteId,
          is_purchasing: true,
        },
      })
        .then((response) => {
          this.stations = response.data;
        })
        .catch((err) => {
          alert(err.response.data.error);
        });
    },
    onTabChange(...args) {
      const newTabId = args[1];
      if (newTabId == 1) {
        // select connection point tab
        this.isPaymentTab = false;
        this.isConnectionDetailsTab = true;
        this.releaseConnection();
      } else if (newTabId == 2) {
        // payment tab
        // pass something to the ConnectionDetails component to clear the dropdown list.
        this.isPaymentTab = true;
      } else if (newTabId == 0) {
        // select site
        this.isPaymentTab = false;
        this.isConnectionDetailsTab = false;
      } else if (newTabId == 3) {
        localStorage.setItem("onHoldConnectionId", 0); //after booking making hold connect to zero
        this.isPaymentTab = false;
        this.isConnectionDetailsTab = false;
      }
    },
    async holdConnection() {
      const response = await HTTP.post("api/v1/transaction/hold", {
        connection_id: this.connectionId,
      });
      return response;
    },
    releaseConnectionCall() {
      if (this.onHoldConnectionId !== 0) {
        return HTTP.delete("api/v1/transaction/hold", {
          data: { connection_id: this.connectionId },
        });
      }
      return null;
    },
    async releaseConnection() {
      try {
        const resp = await this.releaseConnectionCall();
        if (resp != null) {
          this.notifyVue(
            "Success",
            "Sucessfully Release Connection from being hold",
            "success"
          );
          localStorage.setItem("onHoldConnectionId", 0);
          this.onHoldConnectionId = 0;
        }
      } catch (err) {
        console.log(err);
        this.notifyVue(
          "Error releasing connection",
          err.response.data.error,
          "error"
        );
      }
    },
    async validateStep(ref) {
      const isFormValid = await this.$refs[ref].validate();

      if (isFormValid) {
        try {
          const resp = await this.holdConnection();
          localStorage.setItem("onHoldConnectionId", this.connectionId);
          this.onHoldConnectionId = this.connectionId;
          return true;
        } catch (err) {
          console.log("err from hold", err);
          this.notifyVue(
            "Error from holding connection",
            err.response.data.error,
            "error"
          );
          return false;
        }
      } else {
        return isFormValid;
      }
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    nextTabOnMaps(payload) {
      const siteInformation = payload;
      this.siteId = siteInformation.id;
      delete siteInformation.stations;
      this.siteInformation = siteInformation;
      this.wizardModel.siteInformation = siteInformation;
      this.getStations(this.siteId);
      this.$refs.wizardForm.nextTab();
    },
    nextTabOnPayment(payload) {
      this.paymentDetails = payload;
      this.$refs.wizardForm.nextTab();
    },
    onConnectionChange(payload) {
      const connectionId = payload;
      this.connectionId = connectionId;
    },
  },
};
</script>
